import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  public text = '';
  constructor() { }

  ngOnInit() {
    // this.text = 'Creating Personalized Offers basis your Profile details';
    // setTimeout(() => {
    //   // this.text = 'Finserv MARKETS is helping <br/> Millions of Indians to Complete <br/> their Financial Goals';
    // }, 3000);

    // setTimeout(() => {
    //   // this.text = 'Wait is Over... <br/> We are almost done…';
    // }, 6000);

  }

}
